import React from 'react';
import { useTranslation } from 'react-i18next';

import aquamanImage from '../../img/aquaman.png';
import styles from './styles.scss';

export const NoConversation = () => {
    const { t } = useTranslation('inbox');

    return (
        <div className={styles.root}>
            <img className={styles.img} src={aquamanImage} alt="No Conversations Selected" />
            <h2 className={styles.title}>{t('noConversation.heading')}</h2>
            <p className={styles.description}>{t('noConversation.description')}</p>
        </div>
    );
};
